import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'app-corner-button',
	templateUrl: './corner-button.component.html',
	styleUrls: ['./corner-button.component.scss']
})
export class CornerButtonComponent {

	@Input() icon : string = "close";
	@Input() adjustMoreToTheCorner : boolean = false;
	@Input() ariaLabel! : string;
	@Output() eeClick = new EventEmitter<void>();
}